import { useInvoiceRefContextMaybe } from "./InvoiceRefContext";
import { useRefRowHighlight } from "./useRefRowHighlight";

export function useInvoiceRowHighlight<TRowId extends string | number>({
    resolveTableRowId,
}: {
    resolveTableRowId: (invoiceId: string) => TRowId | undefined;
}) {
    const invoiceRefCtx = useInvoiceRefContextMaybe();
    return useRefRowHighlight({
        focusedId: invoiceRefCtx?.focusedInvoiceId ?? null,
        resolveTableRowId,
    });
}
